import classNames from 'clsx';
import { camelCase } from 'lodash';
import React from 'react';

import type { Tournament } from '../../../../types/MTT';

import styles from './Tags.scss';

export interface Tag {
  title: string;
  color: string;
}

export interface TagProps {
  tags: Tournament['tags'];
  className?: string;
}

const Tags: React.FC<TagProps> = ({ tags, className = '' }) => (
  <div className={classNames(styles.gameTags, className)}>
    {tags?.map((tag: Tag, i: number) => (
      <span key={i} className={classNames(styles.tag, styles[camelCase(tag.color)])}>
        <span className={styles.text}>{tag.title}</span>
      </span>
    ))}
  </div>
);

export default Tags;
